module.exports = __webpack_public_path__ + "static/media/user_circle.20552a33.svg";